export default "__VITE_ASSET__BZkGOkpi__"